import { IResultPerLitterTableData } from "shared/api/api";

export const SYNC_DATA_RESULT_PER_LITTER_DATA = 'SYNC_DATA_RESULT_PER_LITTER_DATA';
export const CLEAR_ANALYSIS_DATA = 'CLEAR_ANALYSIS_DATA'
export interface ResultPerLitterState  {
    data?: IResultPerLitterTableData;
    loading: boolean;
}
